import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import {
  PLATE_SIZE_DETAILS_NAMESPACE,
  PLATE_SIZE_DETAILS_NAMESPACE_ACTION,
  BUFFER_OPTIONS,
  PURIFICATION_OPTIONS,
  QUALITY_TESTING_OPTIONS
} from 'src/constants/forms';
import { selectStateData } from 'src/core/redux/selectors';
import { addDetails as addDetailsAction } from 'src/actions';
import { selectFileData } from 'src/components/OligoDNA/components/UploadPlateTemplate/selectors';
import { DoubleSideLayout } from 'src/components';
import { SummaryCard } from 'src/components/OligoDNA/components';

import {
  getPlateSizesConfig,
  getShippingFormatConfig,
  getSynthesisScaleConfig,
  getWellVolumeConfig,
} from './config';
import PlateSizeAndDetails from './PlateSizeAndDetailsComponent';

const PlateSizeAndDetailsContainer = ({
  file = {},
  formData,
  addFormData,
}) => {
  const plateSize = file.additionalData?.plateSize;
  const onChangeData = (value, fieldName, isValid) => addFormData({
    ...formData,
    [fieldName]: { value, isValid },
  });

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <DoubleSideLayout
      leftContent={(
        <PlateSizeAndDetails
          {...{
            formData: formData || {},
            onChangeData,
            plateSizeConfig: getPlateSizesConfig(plateSize),
            wellVolumeConfig: getWellVolumeConfig(plateSize),
            scaleConfig: getSynthesisScaleConfig(),
            purificationConfig: PURIFICATION_OPTIONS,
            bufferConfig: BUFFER_OPTIONS,
            qualityTestingConfig: QUALITY_TESTING_OPTIONS,
            shippingFormatConfig: getShippingFormatConfig()
          }}
        />
      )}
      rightContent={<SummaryCard />}
    />
  );
};

PlateSizeAndDetailsContainer.propTypes = {
  file: PropTypes.object,
  formData: PropTypes.object,
  addFormData: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  file: selectFileData(state),
  formData: selectStateData(PLATE_SIZE_DETAILS_NAMESPACE)(state),
});

const mapDispatchToProps = {
  addFormData: addDetailsAction(PLATE_SIZE_DETAILS_NAMESPACE_ACTION),
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PlateSizeAndDetailsContainer);
